// extracted by mini-css-extract-plugin
export default {"item":"Item_item__TL5er","active":"Item_active__kYkDz"};